import { FC, ReactNode } from 'react'
import { Provider as AlertProvider, positions, transitions } from 'react-alert'
import { I18nextProvider } from 'react-i18next'
import { Provider } from 'react-redux'

import noise from '@/assets/img/noise.png'
import i18n from '@/core/i18n'

import { store } from '../core/store'
import { AlertTemplate } from './AlertTemplate'
import { ThemeProvider } from './ThemeProvider'

interface IRootProps {
  children: ReactNode
}

const options = {
  timeout: 6000,
  position: positions.TOP_CENTER,
  transition: transitions.SCALE,
}

export const Root: FC<IRootProps> = ({ children }) => {
  return (
    <I18nextProvider i18n={i18n}>
      <AlertProvider template={AlertTemplate} {...options}>
        <Provider store={store}>
          <ThemeProvider>
            <div className='Root' style={{ backgroundImage: `url(${noise})` }}>
              <div className='Root-content'>{children}</div>
            </div>
          </ThemeProvider>
        </Provider>
      </AlertProvider>
    </I18nextProvider>
  )
}
